import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Item} from '../../models/Item';
import {ItemConfig} from '../../models/ItemConfig';
import {BehaviorSubject, ReplaySubject, Subscription} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {INPUT_TYPE_FILE} from '../../interfaces/constants';
import {GlobalEventsService} from 'src/app/services/global-events.service';
import {ImageModalComponent} from "../../components_2.1/image-modal/image-modal.component";
import {ImageInputService} from '@src/app/services/ImageInputService/image-input.service';

declare var Yiit;

export interface FileInputSettings {
  key: string;
  value: {
    buttonText?: string;
    static: boolean;
    showInPopup: boolean;
    type: string;
    value: string;
  };
}


@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss']
})
export class FileInputComponent implements OnInit, AfterViewInit, OnDestroy {

  public Yiit = Yiit;
  public modalConfig: any = {};

  private _settings: FileInputSettings;

  @Input()
  set setting(val: FileInputSettings) {
    this._settings = val;
    console.log('this._settings', this._settings);
    this.updateButtonMsg(val);
  }

  get setting(): FileInputSettings {
    return this._settings;
  }

  get allowChangeFile(): boolean {
    return true;
  }

  @Input() item: Item;

  @ViewChild(ImageModalComponent, {static: false}) modal: ImageModalComponent;
  @ViewChild('btn', {static: false}) btn: ElementRef;

  private btnText = [Yiit.t('Upload File'), Yiit.t('Change File'), Yiit.t('Uploading...'), Yiit.t('Uploaded'), Yiit.t('Upload Failed')];
  private allowedTypes = ['png', 'jpg', 'jpeg', 'gif', 'svg', 'svg+xml'];
  private destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private opennedModalSubs: Subscription;

  public buttonMsg: BehaviorSubject<string> = new BehaviorSubject('');

  private _errorMsg: string = null;
  set errorMsg(val: string) {
    this._errorMsg = val;
    this.eventService.ToastNotificationEvent.emit({
      message: this.errorMsg,
      title: 'File upload error',
      classes: ['error']
    });
  }
  get errorMsg(): string | null {
    return this._errorMsg;
  }

  constructor(private http: HttpClient, private eventService: GlobalEventsService, private cd: ChangeDetectorRef, private iis:ImageInputService) {
  }

  ngOnInit(): void {
    this.modalConfig.title = this.item.getTitle();
    this.modalConfig.imgType = this.setting.value.type;
    this.modalConfig.imageUrl = (
      this.setting.value.value
      && this.setting.value.value.trim().length > 0
      && this.isAllowedImg()
    ) ? this.setting.value.value : null;
    this.iis.modalConfig = this.modalConfig;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  ngAfterViewInit(): void {
    this.initListeners();
  }

  private isAllowedImg() {
    let fileType = this.setting.value.value.toLowerCase();
    const index = fileType.lastIndexOf('.');
    fileType = fileType.substr(index + 1, fileType.length);
    return this.allowedTypes.includes(fileType);
  }

  initListeners() {

    // note: config.subject and config.serverUpdate possible do the job twice since setter already call to change btn
    this.item.config.subject
      .pipe(takeUntil(this.destroy$))
      .subscribe((newConfig: ItemConfig) => {
        this.processNewConfig(newConfig);
      });

    this.item.config.serverUpdate
      .pipe(takeUntil(this.destroy$))
      .subscribe((newConfig: ItemConfig) => {
        this.processNewConfig(newConfig);
      });

    this.item.getSubject(Item.OBJECT_CLICK)
      .pipe(takeUntil(this.destroy$))
      .subscribe((isCtrl) => {
        if (!isCtrl && this.setting.value && this.setting.value.value) {
          this.showFileModal();
        }
      });
  }

  private processNewConfig(newConfig: ItemConfig) {
    this.updateButtonMsg(newConfig[this.setting.key] as FileInputSettings);
  }

  private updateButtonMsg(config: FileInputSettings): void {
    if (!config) {
      return;
    }

    if (config.value) {
      if (!this.allowChangeFile && config.value.buttonText) {
        this.buttonMsg.next((this.allowChangeFile) ? this.btnText[1] : config.value.buttonText);
      } else {
        this.buttonMsg.next((config.value.value && config.value.value.trim().length > 0) ? this.btnText[1] : this.btnText[0]);
      }
    }
  }

  canEditItem(item) {
    return true;
  }

  getInputProp() {
    return this.item.config.getInputProp(this.setting.key, 'value');
  }

  uploadFile(item: Item, setting, event) {
    // const self = this;
    const fileRef = event.target.files[0];

    if (fileRef) {
      this.btn.nativeElement.innerText = this.btnText[2];
      this.cd.detectChanges();
      const f = fileRef; // FileList object

      const reader = new FileReader();

      // Closure to capture the file information.
      reader.onload = ((theFile) => {
        this.errorMsg = null;
        return (e) => {
          const data = e.target.result.split(';base64,')[1];
          this.uploadDataToServer(theFile.name, data)
            .pipe(takeUntil(this.destroy$))
            .subscribe((resultUrl) => {
              this.btn.nativeElement.innerText = this.btnText[3];
              item.config.setInputValue(setting.key, 'value', resultUrl);
                this.modalConfig.imageUrl = resultUrl;
                this.iis.modalConfig = this.modalConfig;
              this.cd.detectChanges();
              this.showFileModal();
            },
            (error) => {
              this.btn.nativeElement.innerText = this.btnText[4];
              this.errorMsg = error.message;
              event.target.value = '';
              this.modalConfig.imageUrl = null;
              this.iis.modalConfig = this.modalConfig;
              this.iis.hideModal();
              this.cd.detectChanges();
              console.error('uploadFile to Server failed', error);
              item.config.setInputValue(setting.key, 'value', '123');
            });

        };
      })(f);

      reader.readAsDataURL(f);
    }

  }

  private uploadDataToServer(fileName, data) {
    const params: HttpParams = new HttpParams({
      fromObject: {
        axios_workaround: btoa(JSON.stringify({
            object_id: this.item.getId(),
            name: fileName, data
          }
        ))
      }
    });
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
    // {object_id: this.item.getId(), name: fileName, data: data}
    return this.http.request('POST', Item.URL_UPLOAD_FILE, {body: params, headers});
  }

  showFileModal(): void {
    return;
    this.errorMsg = null;
    this.iis.openModal();
  }

  isAcceptableFile(): boolean {
    return this.setting.value.hasOwnProperty('type')
      && (this.setting.value.type === INPUT_TYPE_FILE);
  }
}
